import DemoRenderer__LegacyDemoInstructions from '@runtime/DemoRenderer';
import InterfaceRenderer__LinkInstructions from '@runtime/TypescriptMetadataRenderer/interface';
import DemoRenderer__LinkInstructions from '@runtime/DemoRenderer';
import legacyImportDemo_3859001748 from "../../../../../packages/component/src/components/card/demo/demo1.js?loadDemo";
import legacyImportDemo_2365998359 from "../../../../../packages/component/src/components/card/demo/demo2.js?loadDemo";
import legacyImportDemo_2429054614 from "../../../../../packages/component/src/components/card/demo/demo3.js?loadDemo";
import legacyImportDemo_2693312785 from "../../../../../packages/component/src/components/card/demo/demo4.js?loadDemo";
import legacyImportDemo_4129838224 from "../../../../../packages/component/src/components/card/demo/demo5.js?loadDemo";
import * as React from 'react';
export default {
  DemoRenderer__LegacyDemoInstructions,
  InterfaceRenderer__LinkInstructions,
  DemoRenderer__LinkInstructions,
  legacyImportDemo_3859001748,
  legacyImportDemo_2365998359,
  legacyImportDemo_2429054614,
  legacyImportDemo_2693312785,
  legacyImportDemo_4129838224,
  React
};